import React from 'react';

export default function SceneMissing() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-black text-white">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-2">No Scene Selected</h1>
        <p className="text-gray-400">Please provide a scene ID in the URL.</p>
      </div>
    </div>
  );
}
